import React from "react";
import {
  Typography,
  Breadcrumbs as Crumbs,
  Box,
  useMediaQuery,
} from "@mui/material";
import Option from "../../types/option";
import { useNavigate } from "react-router-dom";
import theme from "../../theme";

interface Props {
  breadcrumbs: Option[];
}

const Breadcrumbs: React.FC<Props> = (props) => {
  const { breadcrumbs } = props;
  const navigate = useNavigate();

  const md = useMediaQuery(theme.breakpoints.up("md"));

  const lastItem = breadcrumbs?.at(-1)?.id;

  const handleClick = (id: number) => {
    if (id !== lastItem) {
      navigate(`/dashboard/${id}`);
    }
  };

  return (
    <Crumbs aria-label="breadcrumb" sx={{ position: "relative" }}>
      {breadcrumbs &&
        breadcrumbs.map((item) => {
          return (
            <Box
              key={item.id}
              onClick={() => handleClick(item.id)}
              sx={{
                cursor: lastItem !== item.id ? "pointer" : "",
              }}
            >
              <Typography
                textAlign="center"
                variant="button"
                color="textPrimary"
                fontSize={md ? "" : "8px"}
              >
                {item.value}
              </Typography>
            </Box>
          );
        })}
    </Crumbs>
  );
};

export default Breadcrumbs;
